/** Success Bridge Academy — marketing content */

export const BRAND = {
  name: 'Success Bridge Academy',
  tagline: 'AI-Powered GED Preparation Platform',
  email: 'successbridgeacademy123@gmail.com',
  phoneDisplay: '+44 7345 060051',
  phoneHref: 'tel:+447345060051',
  website: 'www.successbridgeacademy.com',
  websiteUrl: 'https://www.successbridgeacademy.com',
  address: 'Pakistan',
};

export const HOME_INTRO = {
  eyebrow: 'GED Program',
  headline: 'Your Path to an American High School Equivalency Credential',
  lead: 'Your path to the GED, with an AI tutor that studies with you.',
  body: [
    'The GED (General Educational Development) program provides an opportunity for individuals who did not complete traditional high school to demonstrate high-school-level knowledge and earn a recognized U.S. high school equivalency credential.',
    'At Success Bridge Academy, we make GED preparation smarter, faster, and more personalized through AI-powered learning technology. Our platform combines an intelligent AI Tutor, personalized study paths, progress monitoring, practice exams, quizzes, and a comprehensive GED course library to help students prepare according to their individual learning needs.',
    'Whether you have completed Grade 10 / O Level, have a study gap, want an alternative pathway to high-school completion, or are looking to strengthen your academic qualifications for future education and career opportunities, our AI-powered GED preparation platform can help you move forward with confidence.',
  ],
};

export const WHAT_IS_GED = {
  title: 'What Is the GED?',
  lead:
    'The GED credential is a U.S. high school equivalency credential designed for individuals who did not complete a traditional high school diploma.',
  body:
    'The GED assessment measures knowledge and skills in four core subject areas. Successful completion of the required GED tests can provide an alternative pathway to high-school-level credentialing and may support applications for higher education, employment, and other opportunities, subject to the admission or eligibility requirements of the relevant institution or organization.',
};

export const AI_FEATURES = [
  {
    icon: 'smart_toy',
    title: 'AI GED Tutor — Available 24/7',
    text: 'Get instant academic assistance whenever you need it. Our AI Tutor helps explain concepts, answer questions, provide guidance, and support your learning journey anytime.',
  },
  {
    icon: 'route',
    title: 'Personalized Study Path',
    text: 'Your learning experience is designed around your individual progress. Focus more on the topics you need to improve while continuing to strengthen your existing knowledge.',
  },
  {
    icon: 'monitoring',
    title: 'Daily Progress Monitoring',
    text: 'Track your learning activity and progress through your personalized dashboard so you can clearly see how far you have come and what you should work on next.',
  },
  {
    icon: 'menu_book',
    title: 'Complete GED Course Library',
    text: 'Access comprehensive learning resources covering the four GED subject areas in one convenient online platform.',
  },
  {
    icon: 'quiz',
    title: 'AI-Powered Quizzes',
    text: 'Practice what you learn with AI-powered quizzes designed to help you identify knowledge gaps and reinforce important concepts.',
  },
  {
    icon: 'assignment',
    title: 'Practice Exams',
    text: 'Prepare for the real assessment environment with practice tests that help you evaluate your readiness and become familiar with different types of GED questions.',
  },
  {
    icon: 'workspace_premium',
    title: 'Mock Exams',
    text: 'Test your preparation under realistic practice conditions and identify the areas that require additional study before your official GED test.',
  },
  {
    icon: 'lightbulb',
    title: 'Smart Learning Experience',
    text: 'Instead of simply following a fixed curriculum, use technology-assisted learning to study at your own pace and focus your preparation where it matters most.',
  },
];

export const GED_FACTS = [
  {
    icon: 'public',
    title: 'A Globally Recognized Credential',
    text: 'The GED credential is widely recognized as a U.S. high school equivalency credential. Acceptance and eligibility can vary by university, employer, government authority, or country, so students should always verify the requirements of their intended institution.',
  },
  {
    icon: 'school',
    title: 'Your Gateway to Higher Education',
    text: 'A GED credential can provide a pathway toward further education. Universities and colleges may have their own admission requirements, so students should confirm GED acceptance directly with their intended institution.',
  },
  {
    icon: 'groups',
    title: 'Millions of GED Graduates',
    text: 'Millions of people around the world have earned a GED credential and used it as a stepping stone toward further education, employment, and personal goals.',
  },
  {
    icon: 'trending_up',
    title: 'A Second Chance to Move Forward',
    text: 'A traditional high-school pathway is not the only way to continue your educational journey. GED preparation can provide an alternative route for eligible students who want to pursue their academic and professional goals.',
  },
];

export const WHO_CAN_BENEFIT = {
  title: 'Who Can Benefit From GED Preparation?',
  lead:
    "Success Bridge Academy's AI-powered GED preparation is designed for students and adults who want a flexible alternative to traditional classroom-based preparation.",
  items: [
    'Did not complete traditional high school',
    'Completed Grade 10 or O Level and want to explore a high-school equivalency pathway',
    'Have experienced a study gap',
    'Want flexible online preparation',
    'Prefer learning at your own pace',
    'Need additional practice before taking the GED tests',
    'Want AI-powered academic assistance',
    'Are preparing for higher education or future career opportunities',
  ],
  note: 'Important: GED eligibility and official testing requirements depend on the jurisdiction and testing authority. Always check the current requirements applicable to you before registering for the official GED tests.',
};

export const WHY_SBA = {
  title: 'Why Success Bridge Academy?',
  headline: "We Don't Just Give You Course Material — We Help You Learn Smarter.",
  lead:
    'Success Bridge Academy is built around a modern approach to GED preparation. Instead of depending entirely on fixed schedules and traditional classroom instruction, our platform gives students access to AI-powered learning tools designed to support independent, personalized preparation.',
  items: [
    { title: '24/7 AI GED Tutor', text: 'Get learning assistance whenever you need it.' },
    { title: 'Personalized Learning Path', text: 'Study according to your individual strengths and weaknesses.' },
    { title: 'Daily Progress Monitoring', text: "Know what you've completed and what you need to improve." },
    { title: 'AI-Based Quizzes', text: 'Practice concepts and identify learning gaps.' },
    { title: 'Practice Exams & Mock Tests', text: 'Build confidence before your official GED assessment.' },
    { title: 'Complete GED Learning Library', text: 'Access resources for all four GED subject areas.' },
    { title: 'Flexible Online Learning', text: 'Study from wherever you are and manage your preparation around your schedule.' },
    { title: 'Progress Dashboard', text: 'Keep your preparation organized and track your journey toward your goals.' },
  ],
};

export const HOME_CLOSING = {
  title: 'Your GED Journey Starts Here',
  body: [
    "You don't have to let a missed high-school opportunity define your future.",
    'With the right preparation, consistent practice, and intelligent learning support, you can take a meaningful step toward your educational goals.',
  ],
  ctaLine: 'Start your GED preparation with Success Bridge Academy and experience a smarter way to learn.',
  tagline: 'Learn Smarter. Prepare Faster. Achieve More.',
};

export const GED_SUBJECTS = [
  {
    id: 'math',
    slug: 'mathematics',
    icon: 'calculate',
    title: 'Mathematical Reasoning',
    short: 'Algebra, geometry, and quantitative reasoning for the GED assessment.',
    color: '#1b365d',
    outcomes: [
      'Solve algebraic equations and inequalities with confidence',
      'Apply geometry and measurement to exam-style problems',
      'Interpret graphs, tables, and quantitative word problems',
      'Build speed and accuracy with AI-graded practice sets',
    ],
    topics: [
      'Number sense & operations',
      'Algebraic expressions',
      'Linear equations',
      'Geometry & measurement',
      'Data & probability',
      'Word-problem strategies',
    ],
  },
  {
    id: 'science',
    slug: 'science',
    icon: 'science',
    title: 'Science',
    short: 'Life, physical, and earth science with clear explanations and quizzes.',
    color: '#005f61',
    outcomes: [
      'Read science passages and extract key evidence',
      'Understand core life, physical, and earth science ideas',
      'Interpret experiments, charts, and scientific claims',
      'Practice AI quizzes that mirror exam reasoning',
    ],
    topics: [
      'Life science foundations',
      'Physical science basics',
      'Earth & space science',
      'Scientific method',
      'Data interpretation',
      'Evidence-based answers',
    ],
  },
  {
    id: 'language-arts',
    slug: 'language-arts',
    icon: 'menu_book',
    title: 'Reasoning Through Language Arts',
    short: 'Reading, writing, and grammar with tutor-style feedback.',
    color: '#8a6d1d',
    outcomes: [
      'Improve reading comprehension across genres',
      'Strengthen grammar, usage, and sentence clarity',
      'Practice writing responses with structured feedback',
      'Build stamina for timed reading sections',
    ],
    topics: [
      'Reading comprehension',
      'Argument & evidence',
      'Grammar & usage',
      'Sentence structure',
      'Writing organization',
      'Revision strategies',
    ],
  },
  {
    id: 'social-studies',
    slug: 'social-studies',
    icon: 'public',
    title: 'Social Studies',
    short: 'Civics, history, economics, and geography — practiced like the real exam.',
    color: '#274874',
    outcomes: [
      'Analyze historical and civic documents',
      'Understand government, economics, and geography basics',
      'Connect sources to exam-style questions',
      'Use AI practice to close knowledge gaps quickly',
    ],
    topics: [
      'Civics & government',
      'U.S. history themes',
      'Economics essentials',
      'Geography & world topics',
      'Primary sources',
      'Map & chart reading',
    ],
  },
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    icon: 'person_add',
    title: 'Enroll online',
    text: 'Create your Success Bridge account with your details, country, and city — it takes a few minutes.',
  },
  {
    step: '02',
    icon: 'payments',
    title: 'Choose your plan',
    text: 'Select a 1, 2, or 3 month study plan. Pricing and discounts are managed by our academy team.',
  },
  {
    step: '03',
    icon: 'auto_stories',
    title: 'Study with AI support',
    text: 'Unlock the full GED course portal: lessons, AI tutor chat, quizzes, and progress tracking.',
  },
  {
    step: '04',
    icon: 'workspace_premium',
    title: 'Practice like the exam',
    text: 'Because the GED final exam is AI-based, our AI practice exams prepare you for first-attempt success.',
  },
];

export const FAQS = [
  {
    q: 'What is Success Bridge Academy?',
    a: 'We are a cloud-based GED preparation academy offering structured study plans, AI tutoring, practice exams, and advisor support for serious learners worldwide.',
  },
  {
    q: 'Which subjects are included?',
    a: 'All four GED subject areas: Mathematics, Science, Language Arts, and Social Studies — with lessons, practice, and progress tracking.',
  },
  {
    q: 'How do study plans work?',
    a: 'Choose 1, 2, or 3 months of full portal access. After enrollment and payment, your dashboard, course, and exams unlock for the plan duration.',
  },
  {
    q: 'Is there an AI tutor?',
    a: 'Yes. Enrolled students get 24/7 AI tutoring inside the course portal for explanations, practice help, and guided review.',
  },
  {
    q: 'Why AI practice exams?',
    a: 'The GED final exam experience is increasingly AI-based. Training with AI quizzes and practice exams builds familiarity and confidence before test day.',
  },
  {
    q: 'Can I study from any country?',
    a: 'Yes. The student portal is cloud-based. During enrollment you select your country and city so we can support you appropriately.',
  },
  {
    q: 'How do I get help from an advisor?',
    a: 'Use the Contact page or email us. Advisors help with enrollment, plan questions, and activation support.',
  },
  {
    q: 'What happens after I pay?',
    a: 'Your subscription activates, locked areas of the student portal open, and you can start lessons, AI tutoring, and practice exams immediately.',
  },
];

export const SUCCESS_STORIES = [
  {
    name: 'Sara K.',
    role: 'GED Graduate · 2 Month Plan',
    initials: 'SK',
    quote:
      'The AI practice exams felt like the real thing. Structured lessons plus advisor check-ins helped me pass on my first attempt.',
    focus: 'Mathematics & Science',
  },
  {
    name: 'Omar R.',
    role: '1 Month Plan Student',
    initials: 'OR',
    quote:
      'I needed a fast runway. The portal kept every subject clear, and the AI tutor answered questions at midnight when I studied.',
    focus: 'Language Arts',
  },
  {
    name: 'Amina T.',
    role: '3 Month Plan Student',
    initials: 'AT',
    quote:
      'Coming back to study after years away felt possible. Weekly progress and Social Studies practice rebuilt my confidence.',
    focus: 'Social Studies',
  },
  {
    name: 'Daniel M.',
    role: 'GED Graduate',
    initials: 'DM',
    quote:
      'Success Bridge gave me a calm, professional path — not random YouTube videos. Plans, exams, and support in one place.',
    focus: 'All subjects',
  },
];

export const BLOG_POSTS = [
  {
    slug: 'what-is-the-ged',
    title: 'What is the GED — and who is it for?',
    excerpt: 'A clear overview of the GED credential, who benefits, and how structured prep changes outcomes.',
    date: '2026-06-12',
    readMins: 5,
    category: 'GED Basics',
    icon: 'school',
    body: [
      'The GED (General Educational Development) credential helps adults demonstrate high-school–level academic skills. It is widely recognized by employers and colleges as a pathway forward when a traditional diploma was interrupted.',
      'At Success Bridge Academy, we serve matric graduates and adult learners who want a serious, guided preparation experience — not scattered free worksheets.',
      'Our program covers all four subject areas with cloud access, AI tutoring, and practice exams designed for today’s AI-influenced testing environment.',
      'If you are ready for a clear plan, start with enrollment, choose a 1–3 month runway, and unlock the full student portal.',
    ],
  },
  {
    slug: 'how-to-choose-a-study-plan',
    title: 'How to choose a 1, 2, or 3 month GED study plan',
    excerpt: 'Match your timeline, work schedule, and subject confidence to the right Success Bridge plan.',
    date: '2026-06-20',
    readMins: 6,
    category: 'Study Plans',
    icon: 'event',
    body: [
      'A 1 month plan fits students who already have strong foundations and can study intensively every day.',
      'A 2 month plan is our most popular balance — enough time for all four subjects, AI practice, and review without burnout.',
      'A 3 month plan supports learners returning to study after time away, or those balancing work and family.',
      'Pricing and discounts are managed by our academy team and shown live on the Pricing page. After payment, your dashboard unlocks immediately.',
    ],
  },
  {
    slug: 'ai-practice-exams-for-ged',
    title: 'Why AI practice exams matter for GED success',
    excerpt: 'The final exam experience is evolving. Train the way you will be tested.',
    date: '2026-07-02',
    readMins: 4,
    category: 'AI Prep',
    icon: 'smart_toy',
    body: [
      'Many students prepare with static PDFs, then feel surprised by adaptive, digital, or AI-assisted exam formats.',
      'Success Bridge includes AI quizzes and practice exams so explanations, pacing, and feedback feel familiar before test day.',
      'Combine AI practice with structured lessons and advisor support — that combination builds both knowledge and exam calm.',
      'Enroll, activate your plan, and use the Exams area of the portal as a weekly habit, not a last-minute scramble.',
    ],
  },
  {
    slug: 'four-subjects-study-rhythm',
    title: 'A simple weekly rhythm across all four GED subjects',
    excerpt: 'Rotate Math, Science, Language Arts, and Social Studies without losing momentum.',
    date: '2026-07-10',
    readMins: 5,
    category: 'Study Tips',
    icon: 'calendar_month',
    body: [
      'Pick two focus subjects per weekday block and protect one longer weekend review session.',
      'Use the AI tutor for stuck problems the same day — do not let confusion compound overnight.',
      'Track progress in the portal so you can see which subject needs more time next week.',
      'Consistency beats cramming. A calm weekly rhythm is how first-attempt passers usually study.',
    ],
  },
];

export function getSubjectBySlug(slug) {
  return GED_SUBJECTS.find((s) => s.slug === slug || s.id === slug);
}

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
